import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import Amplify, { Auth, API } from 'aws-amplify';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Reset } from 'styled-reset';

import awsConfig from '@config/aws';
import Button from '@shared/Button';
import Footer from '@shared/Footer';
import Spinner from '@shared/Spinner';
import { ReactComponent as Logo } from '@src/assets/logo-enigma.svg';
import theme from '@styled/Theme';

import LoggedInUser from './loggedInUser';

// Amplify.configure(awsConfig);
Auth.configure(awsConfig);
API.configure(awsConfig);

const StyledLogo = styled(Logo)`
  width: 116px;
`;

const Container = styled.div`
  margin: 0px auto;
  padding-top: 30vh;
  height: 80vh;
  width: 100%;
  text-align: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 12px;
  h1 {
    padding: 20px 0;
    font-size: 24px;
  }
`;

const FooterContainer = styled.div`
  bottom: 50px;
  right: 10px;
  position: fixed;
`;

const ProviderWrapper = () => {
  // const oauthConfig = awsConfig.Auth.oauth;
  const { user } = useAuthenticator(context => [context.user]);
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Reset />
        {user ? (
          <div>
            <Authenticator.Provider>
              <LoggedInUser />
            </Authenticator.Provider>
          </div>
        ) : (
          <>
            <Container slot='sign-in'>
              <StyledLogo />
              <h1>Screen UI</h1>
              <Button
                analyticsName='SSO Sign In'
                onClick={() => Auth.federatedSignIn()}
              >
                Sign In
              </Button>
              <FooterContainer>
                <Footer />
              </FooterContainer>
            </Container>
          </>
        )}
      </ThemeProvider>
    </div>
  );
};

export default ProviderWrapper;
